<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Hand Filled" class="d-icon d-icon--hand-filled" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6.14.555a.724.724 0 0 1 .723.723v3.531a.454.454 0 0 0 .908 0V1.867a.723.723 0 1 1 1.446 0v3.53a.454.454 0 0 0 .908 0V3.044a.723.723 0 0 1 1.447 0v4.12a4.255 4.255 0 0 1-3.934 4.243l.007.012H6.14c-1.43 0-2.299-.401-3.056-1.102l-.003-.003-.146-.14-.004-.004L.7 7.827a.728.728 0 0 1-.113-.17A.95.95 0 0 1 .7 6.45a.95.95 0 0 1 1.11-.168l.06.034.004.002.004.003.05.033.007.006.008.006.053.043.01.009.01.009.639.656.026.022a.228.228 0 0 0 .358-.168l.001-.023v-.207l.001-.552c.001-.455.002-1.06.005-1.656v-.205l.003-.839.02.037v-.597l-.004-.734v-.255l-.001-.022v-.018a.723.723 0 1 1 1.446 0V5.1a.454.454 0 0 0 .908 0V1.278A.723.723 0 0 1 6.14.555Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHandFilled',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
